const arrayToObjectByKey = (array, keyOfObjectFromArray) => {
    const createdObject = {}
    array.forEach(column => {
        createdObject[column[keyOfObjectFromArray]] = column
    })

    return createdObject
}

export default arrayToObjectByKey
